import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { navigate } from "@reach/router";
import {
  InsightsGrid,
  CardTitle,
  CardDescription,
} from "../NewLandingPage/components/ODRInsightsComponent";
import { PrimaryCTAButton } from "../../common/CustomButtons";
import { Images } from "../../../assets/images";
import { Hero } from "./Webinar";
import { Container } from "./Awards";
import { PageLoader } from "../NewLandingPage/components/PageLoader"; // ← Your existing loader
import Img1 from "../../../assets/images/Commercial-disputes-01.png";
import Img2 from "../../../assets/images/Family-disputes-01.png";
import Img3 from "../../../assets/images/Justact-mailers-expert-01.png";
import Img4 from "../../../assets/images/JustActMailers_MSME Part 2-01.png";
import Img5 from "../../../assets/images/JustActMailers_MSME-01.png";
import Img6 from "../../../assets/images/JustActMailers_SME-01.png";
import Img7 from "../../../assets/images/JustActMailers_1.1 Arbitrators-01.png";
import Img8 from "../../../assets/images/JustActMailers_country.png";
import Img9 from "../../../assets/images/JustActMailers_10-13.jpeg";
import Img10 from "../../../assets/images/JustActMailers_10-11.jpg";
import Img11 from "../../../assets/images/Limitatin In Arbitration.jpg";
import Img12 from "../../../assets/images/JustActMailers_10-09.jpg";
import Img13 from "../../../assets/images/JustActMailers_6_V2-02.jpg";
import Img14 from "../../../assets/images/JustActMailers_10-01.jpg";
import Img15 from "../../../assets/images/JustActMailers_6_V2-01.jpg";
import Img16 from "../../../assets/images/JustActMailers_9_V1-02.jpg";
import Img17 from "../../../assets/images/JustActMailers_7_V2-01.jpg";
import Img18 from "../../../assets/images/Creative for JA Blog - 27.06.23.jpg";
import Img19 from "../../../assets/images/JustActMailers_9_V1-01.jpg";
import Img20 from "../../../assets/images/JustAct Blog Creative 20.03.23.jpg";
import Img21 from "../../../assets/images/JustActMailers_7_V1-01.jpg";
import Img22 from "../../../assets/images/Mediation picture (1).jpg";
import Img23 from "../../../assets/images/Trackling_Thumbnail.png";
import Img24 from "../../../assets/images/JA Thumbnail.png";
import Img25 from "../../../assets/images/Thumbnail_S1129A.png";
import Img26 from "../../../assets/images/Thumbnail_Nitika.png";
import Img27 from "../../../assets/images/Thumbnail_Vismita.png";
import Img28 from "../../../assets/images/Thumbnail4.png";
import Img29 from "../../../assets/images/Thumbnail3.png";
import Img30 from "../../../assets/images/Thumbnail2.png";
import Img31 from "../../../assets/images/Thumbnail.png";
import Img32 from "../../../assets/images/Thumbnail.png";
import fallbackImg from "../../../assets/images/Ai-powerd.png";

const actions = [
  {
    image: Img1,
    heading: "Mediation in Commercial Disputes",
    body: `The Commercial Courts Act, 2015 was enacted by the Parliament in order to facilitate ease of 
      doing business and encourage foreign capital and investment in the country...`,
    path: "/blog/commercial-disputes",
  },
  {
    image: Img2,
    heading: "Mediation in Family Matterss",
    body: `Interpersonal and professional relationships oriented towards the long term are prone to
      conflict and rupture...`,
    path: "/blog/mediation-in-family",
  },
  {
    image: Img3,
    heading: "Experts as Arbitrators",
    body: `In a fast-paced world where disputes between private parties are gaining in complexity and
      value, the need for experts as arbitrators has increased greatly...`,
    path: "/blog/experts-as-arbitrators",
  },
  {
    image: Img4,
    heading:
      "ADR PROCESSES WITHIN THE MICRO, SMALL AND MEDIUM ENTERPRISES DEVELOPMENT ACT, 2006 Part II",
    body: `It was held in this judgment 1 that "there is no provision in the Act, which negates or renders
      the arbitration agreement entered between the parties ineffective"...`,
    path: "/blog/enterprises-development-part-two",
  },
  {
    image: Img5,
    heading:
      "ADR PROCESSES WITHIN THE MICRO, SMALL AND MEDIUM ENTERPRISES DEVELOPMENT ACT, 2006 Part I",
    body: `The Micro, Small &amp; Medium Enterprises (MSMEs) have a pivotal role to play in the creation
      of employment opportunities within developing areas of the country...`,
    path: "/blog/enterprises-development-part-one",
  },
  {
    image: Img6,
    heading: "ROLE OF MEDIATION IN SME DISPUTES",
    body: `Small and Medium Sized Enterprises (SME) are categorized as businesses whose investment,
      revenue and employee base are restricted to predetermined limits...`,
    path: "/blog/role-of-mediation",
  },
  {
    image: Img7,
    heading:
      "What Kind of Training is Required to Build a Country of Arbitrators?",
    body: `Arbitration in India has evolved over the preceding centuries to become one of the most well-
      regarded modes of dispute resolution, especially in the commercial world...`,
    path: "/blog/country-of-arbitrators",
  },
  {
    image: Img8,
    heading:
      "What Kind of Training is Required to Build a Country of Mediators?",
    body: `Mediation is gaining ground as a mainstream dispute resolution process for settling
      commercial and financial disputes across the world...`,
    path: "/blog/country-of-mediators",
  },
  {
    image: Img9,
    heading:
      "Breaking Impasses in Settlement Conferences: Five Techniques for Resolution",
    body: `An impasse signifies a stalemate or deadlock in discussions when parties are unwilling to
      budge from their respective positions for stated reasons...`,
    path: "/blog/technique-for-resolution",
  },
  {
    image: Img10,
    heading: "SUBJECT MATTER EXPERTS IN ARBITRATIONS",
    body: `The increase in the volume of global trade has led to a corresponding rise in commercial and
      financial disputes being referred to various mechanisms of dispute resolution...`,
    path: "/blog/experts-in-arbitration",
  },
  {
    image: Img11,
    heading: "LIMITATION IN ARBITRATION Part II",
    body: `This article will further discuss the shortcomings of the application of limitation in arbitration
      proceedings through the following entry points...`,
    path: "/blog/limitation-in-arbitration-two",
  },
  {
    image: Img12,
    heading: "NON-ARBITRABLE CASES",
    body: `The case is foundational to the development of the parameters of non-arbitrability of disputes and the Supreme 
      Court laid down general rules in this regard while adjudicating on whether an action for the enforcement of a mortgage is arbitrable...`,
    path: "/blog/non-arbitrable-cases-two",
  },
  {
    image: Img13,
    heading: "Role of Arbitration in Criminal Cases",
    body: `However, this position on fraud as a criminal offence and the arbitrability of such disputes saw a shift 
      in the emerging jurisprudence of the later years, thus underlining the role of arbitration in criminal cases...`,
    path: "/blog/role-of-arbitration-in-criminal-cases-part-2",
  },
  {
    image: Img14,
    heading: "Mediation Act, 2023",
    body: `In the labyrinth of legal battles, where adversarial swords clash, there exists a quieter path—a path illuminated by
      dialogue, empathy, and mutual understanding.`,
    path: "/blog/mediation-act-2023",
  },
  {
    image: Img15,
    heading: "Role of Arbitration in Criminal Cases",
    body: `Arbitral tribunals generally possess the jurisdiction to adjudicate upon civil and commercial
      disputes subject to the dispute being covered under the arbitration...`,
    path: "/blog/role-of-arbitration-in-criminal-cases",
  },
  {
    image: Img16,
    heading: "Enforcement of Foreign Arbitral Awards",
    body: `Prior to the enactment of The Arbitration and Conciliation Act, 1996 which was modelled on the UNCITRAL Model Law, the Arbitration Act, 1940 was enacted to consolidate and amend the law relating to arbitration...`,
    path: "/blog/enforcement-of-foreign-arbitral-awards",
  },
  {
    image: Img17,
    heading: "LIMITATION IN ARBITRATION",
    body: `The Limitation Act, 1963 is a legislation that bars legal remedy
        to those who have not exercised their right to act on a
        particular issue within the bounds...`,
    path: "/blog/limitation-in-arbitration",
  },
  {
    image: Img18,
    heading: "TIME & COST BENEFITS OF ARBITRATION & MEDIATION",
    body: `Although the traditional court system is associated primarily
      with the dispensation of justice, methods of Alternative Dispute
      Resolution...`,
    path: "/blog/time-cost-benefits-of-arbitration-mediation",
  },
  {
    image: Img19,
    heading: "NON-ARBITRABLE CASES",
    body: `Alternative Dispute Resolution as a means of settling disputes
      out of court is gaining precedence across the world. Most
      disputes that arise may be resolved...`,
    path: "/blog/non-arbitrable-cases",
  },
  {
    image: Img20,
    heading: `Perkins Eastman Judgement: Impact on the Appointment of a Sole
      Arbitrator`,
    body: `The judgement examined whether a case was made out for the
      exercise of power by the Court to make an....`,
    path: "/blog/perkins-eastman-judgement",
  },
  {
    image: Img21,
    heading: "Enforcement of Foreign Arbitral Awards",
    newIcon: "",
    body: `Effective and speedy dispute resolution mechanisms for domestic
      and global investors are essential in order to facilitate....`,
    path: "/blog/enforcement-of-foreign-arbital-awards",
  },
  {
    image: Img22,
    heading: "Culture of mediation: why has it not picked up in India?",
    body: `Alternate Dispute Resolution (ADR) refers to modes by which
      disputes may be resolved without taking recourse to the court
      system...`,
    path: "/blog/culture-of-mediation-why-has-it-not-picked-up-in-india",
  },
  {
    image: Img23,
    heading: "Tackling pending cases in Indian Courts",
    body: `Every year, a minimum of five crore cases are filed across
      various courts of India. Even as some of these cases stay
      pending...`,
    path: "/blog/tackling-pending-cases-in-indian-courts",
  },
  {
    image: Img24,
    heading: "Advantages of ODR",
    body: `The world now bears witness to an unprecedented situation, with
        the pandemic and its conditions rendering aspects far from a
        sense of normal...`,
    path: "/blog/advantages-of-ODR",
  },
  {
    image: Img25,
    heading:
      "Section 11 & 29A: Impeding or expediting the Arbitration process?",
    body: `Through the present health catastrophe that the world knows as
        COVID-19, arbitration has been shown to adapt better...`,
    path: "/blog/impeding-or-expediting-the-arbitration-process",
  },
  {
    image: Img26,
    heading:
      "Evaluating ADR for resolving women-related disputes (Part 3 of 3)",
    body: `Arbitration, mediation, or consultation exemplify Alternative
      Conflict Resolution (ADR)...`,
    path: "/blog/evaluating-ADR-for-resolving-women-related-disputes",
  },
  {
    image: Img27,
    heading: "ADR and its applications to women-related disputes (Part 2 of 3)",
    body: `Violence against women is a matter of grave concern. The
      immediate and long-term physical, sexual, and mental
      consequences...`,
    path: "/blog/ADR-and-its-applications-to-women-related-disputes",
  },
  {
    image: Img28,
    heading: " Resolving women-related disputes (Part 1 of 3)",
    body: `Women are victims of different social evils. They are subjected
      to problems at their homes, at the workplace, in society, etc.
      One of the significant...`,
    path: "/blog/resolving-women-related-disputes",
  },
  {
    image: Img29,
    heading: "The scope and relevance of ODR",
    body: `These are the wise words of the man who is credited with
      inventing the world wide web, and a rather telling observation
      by him. We can hardly imagine a world...`,
    path: "/blog/the-scope-and-relevance-of-ODR",
  },
  {
    image: Img30,
    heading: "Understanding Arbitration and The Arbitration Act",
    body: `Dispute Resolution uses the mechanisms of Negotiation and
        Mediation in order to let parties arrive at a consensual
        resolution...`,
    path: "/blog/understanding-arbitration-and-the-arbitration-act",
  },
  {
    image: Img31,
    heading: "Online Dispute Resolution: Opportunities and challenges",
    body: `Embracing an idea means embracing its methods. Embracing ODR
      needs to be done rapidly but not at the cost of sacrificing the
      principles...`,
    path: "/blog/online-dispute-resolution-opportunities-and-challenges",
  },
  {
    image: Img32,
    heading: "The basics of Online Dispute Resolution",
    body: ` Before and through the pandemic, the world changed radically.
        One would observe that there is a massive concentration of
        wealth...`,
    path: "/blog/the-basics-of-online-dispute-resolution",
  },
];

const BlogImage = ({ src, alt }) => {
  return (
    <StyledBlogImage
      src={src}
      alt={alt}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src =
          fallbackImg ||
          `https://ui-avatars.com/api/?name=${encodeURIComponent(
            alt || "Blog"
          )}&size=400&background=00838c&color=fff&bold=true`;
      }}
    />
  );
};

function Blog() {
  const ITEMS_PER_PAGE = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const totalPages = Math.ceil(actions.length / ITEMS_PER_PAGE);
  const paginatedData = actions.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const currentPageImages = paginatedData.map((item) => item.image);

  const preloadImages = (imageList) => {
    if (imageList.length === 0) {
      setImagesLoaded(true);
      return;
    }

    let loadedCount = 0;
    const total = imageList.length;

    imageList.forEach((src) => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === total) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === total) {
          setImagesLoaded(true);
        }
      };
      img.src = src;
    });
  };

  const changePage = (newPage) => {
    if (newPage === currentPage) return;

    setImagesLoaded(false);
    setCurrentPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    setImagesLoaded(false);
    preloadImages(currentPageImages); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Blog - Dispute Resolution Online - JustAct</title>
        <meta
          name="description"
          content="IAMC blogs on technology-assisted dispute resolution services including negotiation, mediation, and arbitration."
        />
        <meta
          name="keywords"
          content="Alternative Dispute Resolution, Dispute Resolution Online, Dispute Blogs, Online Arbitration, Online Mediation, Online Dispute Resolution, IAMC"
        />
      </Helmet>
      <PageLoader isLoading={!imagesLoaded} />
      <Hero bgImage={Images.blog}>
        <h1>Blogs</h1>
      </Hero>

      <InsightsGrid>
        {paginatedData.map((item, index) => (
          <InsightCard key={`${currentPage}-${index}`}>
            <CardHeaderWrapper>
              <BlogImage src={item.image} alt={item.heading} />
            </CardHeaderWrapper>
            <CardTitle>{item.heading}</CardTitle>
            <CardDescription>{item.body}</CardDescription>
            <ButtonWrapper>
              <PrimaryCTAButton onClick={() => navigate(item.path)}>
                Read More
              </PrimaryCTAButton>
            </ButtonWrapper>
          </InsightCard>
        ))}
      </InsightsGrid>

      <PaginationWrapper>
        <PageButton
          disabled={currentPage === 1}
          onClick={() => changePage(currentPage - 1)}
        >
          Prev
        </PageButton>

        {[...Array(totalPages)].map((_, i) => (
          <PageNumber
            key={i}
            active={currentPage === i + 1}
            onClick={() => changePage(i + 1)}
          >
            {i + 1}
          </PageNumber>
        ))}

        <PageButton
          disabled={currentPage === totalPages}
          onClick={() => changePage(currentPage + 1)}
        >
          Next
        </PageButton>
      </PaginationWrapper>
    </Container>
  );
}

export default React.memo(Blog);

// Styled Components (keep your sharp image styles)

const InsightCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

const StyledBlogImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  transition: transform 0.3s ease;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;

  ${InsightCard}:hover & {
    transform: scale(1.05);
  }
`;

const CardHeaderWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 1rem;
  background-color: #f0f8f8;
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
  padding-top: 1rem;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 40px 0;
`;

const PageButton = styled.button`
  padding: 8px 14px;
  border: none;
  background: #00818a;
  color: white;
  border-radius: 6px;
  cursor: pointer;

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const PageNumber = styled.button`
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #00818a;
  background: ${(p) => (p.active ? "#00818a" : "white")};
  color: ${(p) => (p.active ? "white" : "#00818a")};
  cursor: pointer;
`;
